import * as React from 'react';
import { ProductInterface } from '../../Model/Product';
import { UriBuilder } from '../../Service/UriBuilder';
import { ProductView } from './ProductView';

export interface ImageProps {
    product: ProductInterface,
    attr: string,
    dontLink?: boolean
}

export class FinderImage extends ProductView<ImageProps> {
    public render() {
        const product = this.props.product;
        const key = this.props.attr;
        const image = this.asset(product, key);
        const imageUrl = `${process.env.REACT_APP_ASSET_URL}`;

        if (image) {
            return this.link(<img className="pf-image" src={imageUrl + image.uri} alt={image.displayString}/>);
        } else {
            return null;
        }
    }

    protected link(content: any): JSX.Element {
        const props = this.props;
        if (props.dontLink) {
            return content;
        }
        const product = props.product;
        const uri = UriBuilder.productUri(product);
        if (!uri) {
            return content;
        }

        if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line react/jsx-no-target-blank
            return <a href={uri} target="_blank">{content}</a>;
        } else {
            return <a href={uri}>{content}</a>;
        }
    }
}
